// src/pages/NewsManagement/ViewNews.jsx
import React from 'react';
import { FaStar, FaFire } from 'react-icons/fa';

function ViewNews({ data }) {
  if (!data) {
    return <div className="text-center py-4">No data available</div>;
  }

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'draft': { class: 'bg-warning', label: 'Draft' },
      'published': { class: 'bg-success', label: 'Published' },
      'archived': { class: 'bg-secondary', label: 'Archived' }
    };
    const statusInfo = statusMap[status?.toLowerCase()] || statusMap['draft'];
    return <span className={`badge ${statusInfo.class}`}>{statusInfo.label}</span>;
  };

  const displayFields = [
    { key: 'title', label: 'News Title' },
    { key: 'description', label: 'Description' },
    { key: 'category', label: 'Category' },
    { key: 'author', label: 'Author' },
    { key: 'status', label: 'Status' },
    { key: 'publish_date', label: 'Publish Date' },
    { key: 'is_featured', label: 'Featured' },
    { key: 'is_breaking', label: 'Breaking' },
    { key: 'image_path', label: 'Image' },
    { key: 'view_count', label: 'Views' },
    { key: 'meta_title', label: 'Meta Title' },
    { key: 'meta_description', label: 'Meta Description' },
    { key: 'meta_keywords', label: 'Meta Keywords' },
    { key: 'created_at', label: 'Created At' },
    { key: 'updated_at', label: 'Updated At' },
  ];

  const getValue = (key) => {
    if (key === 'status') {
      return getStatusBadge(data[key]);
    }
    if (key === 'is_featured') {
      return data[key] ? <span className="badge bg-warning text-dark"><FaStar className="me-1" /> Featured</span> : 'No';
    }
    if (key === 'is_breaking') {
      return data[key] ? <span className="badge bg-danger"><FaFire className="me-1" /> Breaking</span> : 'No';
    }
    if (key === 'image_path') {
      return data[key] ? (
        <img 
          src={data[key]}
          alt="News" 
          style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
          className="img-thumbnail"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/placeholder-image.png';
          }}
        />
      ) : 'No Image';
    }
    if (key === 'publish_date' || key === 'created_at' || key === 'updated_at') {
      return formatDate(data[key]);
    }
    return data[key] || 'N/A';
  };

  return (
    <div className="view-news-container">
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <tbody>
            {displayFields.map((field) => (
              <tr key={field.key}>
                <th style={{ width: '35%', backgroundColor: '#f8f9fa' }}>
                  {field.label}
                </th>
                <td>{getValue(field.key)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewNews;